// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

// local imports
import { PropertyDto } from "@app/catalog";

export class PropertyModel 
{
    public id: string = "";    
    public name: WritableSignal<string>;
    public values: WritableSignal<string[]>;

    constructor()
    {                
        this.name = signal<string>(null);      
        this.values = signal<string[]>([]);    
    }

    public static fromDto(dto: PropertyDto)
    {
        let propertyModel = new PropertyModel();

        propertyModel.id = dto.id;
        propertyModel.name.set(dto.name);
        propertyModel.values.set(dto.values);
        return propertyModel;
    }
}
